export default __webpack_public_path__ + "static/media/google-chrome.be965a4a.ico";